import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import axios from 'axios'
import i18n from './lang'
import Vant from 'vant'
import 'vant/lib/index.css'

import VueGtag from "vue-gtag";
import SocialSharing from 'vue-social-sharing'

Vue.use(SocialSharing);

Vue.use(VueGtag, {
  config: { 
    id: "UA-139106547-1",
    // pageTrackerTemplate(to) {
    //   return {
    //     page_title: 'PPPoker',
    //     page_path: to.path
    //   }
    // }
  }
}, router);


axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_AXIOS
Vue.prototype.$axios = axios
Vue.use(Vant)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
